// extracted by mini-css-extract-plugin
module.exports = {"item":"AdminCategories_item__1z_hN","editModal":"AdminCategories_editModal__1le8U"};
    if(module.hot) {
      // 1686459253963
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  